export default "__VITE_ASSET__BoNKJHc6__";